module.exports = __webpack_public_path__ + "img/1747038602_8bST.af4f32fd.jpg";